import { Component, Input } from '@angular/core';

/**
 * Presentational component — inline field error row with red filled-circle × icon + message text.
 * Renders nothing when `message` is empty/falsy.
 *
 * Usage:
 *   <app-healthpicks-field-error [message]="errorMessages.login.email"></app-healthpicks-field-error>
 */
@Component({
  selector: 'app-healthpicks-field-error',
  template: `
    <p class="hp-field-error" *ngIf="message" role="alert">
      <span class="hp-field-error__icon" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <circle cx="8" cy="8" r="6.4" fill="#BE4751"/>
          <path
            d="M10.18 5.02c.15-.15.39-.15.53 0 .15.15.15.39 0 .53L8.53 7.73l2.18 2.18c.15.15.15.39 0 .53-.15.15-.39.15-.53 0L8 8.26l-2.18 2.18c-.15.15-.39.15-.53 0-.15-.15-.15-.39 0-.53l2.18-2.18L5.29 5.55c-.15-.15-.15-.39 0-.53.15-.15.39-.15.53 0L8 7.2l2.18-2.18z"
            fill="white"
          />
        </svg>
      </span>
      <span class="hp-field-error__text">{{ message }}</span>
    </p>
  `,
  styles: [`
    .hp-field-error {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      margin: 0;
      color: #c0392b;
      font-family: var(--hp-font) !important;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.4;
      letter-spacing: 0.36px;
      font-feature-settings: 'halt';
    }

    .hp-field-error__icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      line-height: 0;
      /* vertically align icon with first line of text */
      margin-top: 1px;
    }

    .hp-field-error__text {
      flex: 1;
      min-width: 0;
    }
    :host {
      display: contents;
    }
  `],
})
export class HealthpicksFieldErrorComponent {
  /** Error message to display. Component is hidden when falsy. */
  @Input() message = '';
}
